import React from "react";
import { CameraIcon, ClipboardCheckIcon, FileTextIcon, LayoutGridIcon, LibraryIcon, PuzzleIcon, BoxIcon } from "lucide-react";
import { extras } from "../../data/content";
import { CtaButton } from "../CtaButton";
const icons: Record<string, BoxIcon> = {
  file: FileTextIcon,
  check: ClipboardCheckIcon,
  puzzle: PuzzleIcon,
  grid: LayoutGridIcon,
  camera: CameraIcon,
  library: LibraryIcon
};
export function Extras() {
  return <section className="bg-navy px-4 py-16 sm:py-20" data-id="element-112" data-mp="3cf0gbujjsxlc">
      <div className="mx-auto max-w-5xl" data-id="element-113" data-mp="37hqsgjbt4tzm">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-114" data-mp="37gyyte1rt6bz">
          Plus, I get <span className="italic text-teal-light" data-id="element-115" data-mp="3lf5m6093fnxe">immediate access</span> to:
        </h2>

        <ul className="mt-10 grid gap-x-8 gap-y-2 md:grid-cols-2" data-id="element-116" data-mp="3gg2jgmgl5tsl">
          {extras.map(e => {
          const Icon = icons[e.icon];
          return <li key={e.title} className="flex gap-4 border-b border-white/10 py-5" data-id="element-117" data-mp="1m4nqlwsa3e8m">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-light text-navy" data-id="element-118" data-mp="vzr338biyqq3">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-119" data-mp="10xsohzwfb24q" />
                </span>
                <div data-id="element-120" data-mp="15x56a68ftj0g">
                  <h3 className="text-lg font-bold leading-snug text-white" data-id="element-121" data-mp="15wnbzf5c5ev6">{e.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/75" data-id="element-122" data-mp="1aoncp9t8cbst">{e.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <CtaButton label="I want the complete planning system" className="mt-10" data-id="element-123" data-mp="1escu9fbhlt4c" />
      </div>
    </section>;
}